import { render, staticRenderFns } from "./NoData2.vue?vue&type=template&id=106f9a86&scoped=true&"
import script from "./NoData2.vue?vue&type=script&lang=js&"
export * from "./NoData2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106f9a86",
  null
  
)

export default component.exports